import { TFunction } from "i18next";
import { UnitKey } from "./types";

export const unitKeys = ["days", "hours", "minutes", "seconds"] as const;

const unitTranslations: Record<
  UnitKey,
  (t: TFunction, count: number) => string
> = {
  days: (t, count) =>
    t("countdownTimer.day", {
      count,
      defaultValue: count === 1 ? "Day" : "Days",
    }),
  hours: (t, count) =>
    t("countdownTimer.hour", {
      count,
      defaultValue: count === 1 ? "Hour" : "Hours",
    }),
  minutes: (t, count) =>
    t("countdownTimer.minute", {
      count,
      defaultValue: count === 1 ? "Minute" : "Minutes",
    }),
  seconds: (t, count) =>
    t("countdownTimer.second", {
      count,
      defaultValue: count === 1 ? "Second" : "Seconds",
    }),
};

export const unitLabel = (t: TFunction, key: UnitKey, count: number) =>
  unitTranslations[key](t, count);

export const formatTime = (value: number) => String(value).padStart(2, "0");
